module.exports = "<a class=\"btn btn-primary font-weight-bold\" href=# data-bind=\"i18n: 'booking.email.btn', attr: { href: href}\">Buchen</a> ";